var __jsx = React.createElement;
import React from 'react';
import Script from 'next/script';
import { useSelector } from 'react-redux';
var P_ID = '93537';
var P_KEY = 'd9f22fd1ffe2a23af33e68348a687ab0'; // pragma: allowlist secret

var TrailGuide = function TrailGuide() {
  var email = useSelector(function (state) {
    var _state$user$current;
    return (_state$user$current = state.user.current) === null || _state$user$current === void 0 || (_state$user$current = _state$user$current.attributes) === null || _state$user$current === void 0 ? void 0 : _state$user$current.email;
  });
  if (!email) return null;
  return __jsx(Script, {
    src: "https://cdn.customgpt.ai/js/chat.js",
    strategy: "afterInteractive",
    onLoad: function onLoad() {
      var _window$CustomGPT;
      var style = document.createElement('style');
      style.textContent = "\n          #cgptcb-chat-circle.cgptcb-icon-size-small  { width: 56px !important; min-width: 56px !important; }\n          #cgptcb-chat-circle.cgptcb-icon-size-medium { width: 88px !important; min-width: 88px !important; }\n          #cgptcb-chat-circle.cgptcb-icon-size-large  { width: 125px !important; min-width: 125px !important; }\n          #cgptcb-chat-circle { box-shadow: 0 0 0 3px #9966b8; transition: box-shadow 0.2s ease; }\n          .cgptcb-chat-bubble:hover #cgptcb-chat-circle { box-shadow: 0 0 0 3px #b6007c; }\n          .cgptcb-body .cgptcb-chat-bubble:hover { outline: none !important; }\n        ";
      document.head.appendChild(style);
      (_window$CustomGPT = window.CustomGPT) === null || _window$CustomGPT === void 0 || _window$CustomGPT.init({
        p_id: P_ID,
        p_key: P_KEY,
        external_id: "".concat(encodeURIComponent(email), "-").concat(encodeURIComponent(window.location.href))
      });
    }
  });
};
export default TrailGuide;